import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// START_FUNCTION_formatCurrency
// START_CONTRACT:
// PURPOSE: Форматирует число как валюту в рублях.
// INPUTS:
// - [Сумма] => amount: number
// OUTPUTS:
// - string - Отформатированная строка с валютой
// END_CONTRACT
export function formatCurrency(amount: number): string {
  return new Intl.NumberFormat('ru-RU', {
    style: 'currency',
    currency: 'RUB',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(amount);
}
// END_FUNCTION_formatCurrency

// START_FUNCTION_formatNumber
// START_CONTRACT:
// PURPOSE: Форматирует число с разделителями тысяч.
// INPUTS:
// - [Число] => num: number
// OUTPUTS:
// - string - Отформатированная строка
// END_CONTRACT
export function formatNumber(num: number): string {
  return new Intl.NumberFormat('ru-RU').format(num);
}
// END_FUNCTION_formatNumber

// START_FUNCTION_formatPhoneNumber
// START_CONTRACT:
// PURPOSE: Форматирует номер телефона в российском формате.
// INPUTS:
// - [Номер телефона] => phone: string | null | undefined
// OUTPUTS:
// - string - Отформатированный номер телефона
// END_CONTRACT
export function formatPhoneNumber(phone: string | null | undefined): string {
  if (!phone) return '';
  
  // Удаляем все нецифровые символы
  const digits = phone.replace(/\D/g, '');
  
  // Если номер начинается с 7 или 8, форматируем как российский
  if (digits.length === 11 && (digits[0] === '7' || digits[0] === '8')) {
    const code = digits[0] === '8' ? '7' : digits[0];
    return `+${code} (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7, 9)}-${digits.slice(9)}`;
  }
  
  // Если номер из 10 цифр, добавляем +7
  if (digits.length === 10) {
    return `+7 (${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 8)}-${digits.slice(8)}`;
  }
  
  // Возвращаем как есть для других форматов
  return phone;
}
// END_FUNCTION_formatPhoneNumber
